import type { CreditData, CreditUsageKey } from '../types';

export const UsageCalculator = Symbol('UsageCalculator');

/**
 * 用量计算器接口
 * 提供用量计算的通用能力
 */
export interface UsageCalculator {
    /**
     * 计算多个用量类型的总剩余量
     * @param creditData - 信用数据
     * @param usageKeys - 用量类型的 key 数组
     * @returns 总剩余量（total - usage 之和）
     */
    calculateTotalRemaining(creditData: CreditData, usageKeys: CreditUsageKey[]): number;
}
